import { render, staticRenderFns } from "./DeliveryActivity.vue?vue&type=template&id=28cf5f2a&"
import script from "./DeliveryActivity.vue?vue&type=script&lang=js&"
export * from "./DeliveryActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports